// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_9tm","cls2":"Timer-cls2_A55 Timer-cls1_9tm"};